import axios from "axios";
import { baseUrl } from "../index";
export const CentralCall = async (URL, model) => {
    return await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, {
        URL,
        PostString: JSON.stringify(model)
    })
}